import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import clsx from 'clsx';


const Link = props => {
  const { activeClassName, exact, match, history, location, staticContext, to, className, ...other } = props;
  let isActive = false;

  if(location.pathname.startsWith(to)) {
    isActive = true;
  }

  return (
    <RouterLink to={to} {...other} className={clsx(className, isActive && activeClassName)}/>
  );
};

Link.propTypes = {
  to: PropTypes.string,
  activeClassName: PropTypes.string,
  exact: PropTypes.bool,
};

const RLink = withRouter(Link);

export default  React.forwardRef((props, ref) => <RLink {...props} innerRef={ref} />);

